import React from "react";

interface SvgProps extends React.SVGProps<SVGSVGElement> {
  size?: "small" | "middle";
}

const ArowSmall: React.FC<SvgProps> = ({ size = 'middle', ...props }) => (
  <>
    {size === "small" && (
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 11L6.5 6L1.5 1"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}

    {size === "middle" && (
      <svg
        width="8"
        height="14"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 13L7 7L1 1"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </>
);

export default ArowSmall;
